import {
  StackScrollTool,
} from "@cornerstonejs/tools";
import { useState, useEffect, useContext, useRef, useCallback } from "react";
import {
  API_BASE_URL,
  APIs,
  COLORS,
  DEFAULT_TOOL,
  HP_META_TAGS,
  HP_OPERANDS,
  REFLINES_SYNC_EXCLUDED_MODALITIES,
  SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST,
  SYNC_MODES,
  VIEWPORT_COLUMN,
  VIEWPORT_ROW,
  XRAY_DEFAULT_TOOL,
  dicomWebURL,
  imageBaseURL,
  showPathologyForModalities,
} from "../../constants/Constants";
import {
  MOUSE_ASSIGNABLE_TOOL_NAMES,
  loadMouseButtonToolAssignments,
  saveMouseButtonToolAssignments,
} from "../../constants/MouseButtonToolAssignments";
import {
  eventBus,
  getViewport,
  getViewportByIdAndRenderingEngine,
  getViewportByIdAndDefRenderingEngine,
  renderViewports,
  rerenderViewport,
  resetViewportTransforms
} from "../../pages/StudyViewer/helpers/CornerstoneViewportService";
import ViewportContext from "./ViewportContext";
import { eventTarget, getEnabledElement, getRenderingEngine  } from "@cornerstonejs/core";
import { uuidv4, getVolumeViewportScrollInfo } from "@cornerstonejs/core/utilities";
import { Enums, annotation } from "@cornerstonejs/tools";
import toolStyle from "@cornerstonejs/tools/annotation/config/ToolStyle";
import { patientViewerState } from "../../pages/Annotations/helper/initialData";
import studyviewerContext from "./StudyviewerContext";
import { resizeViewport } from "../../pages/StudyViewer/helpers/CornerstoneViewportService";
import { buildSeriesDataFromStack } from "../../pages/StudyViewer/helpers/ViewerHelperService";
import {
  empty3DJsonData,
  getAllFourCoordinates,
  getTextAnnotation3DObject,
  getTextAnnotationLegacyData,
  getUpdatedJson,
} from "../../pages/StudyViewer/helpers/BoundingBoxUtilities";
import loaderContext from "../loader/LoaderContext";
import toastContext from "../toast/ToastContext";
import { removeAnnotation } from "@cornerstonejs/tools/annotation/annotationState";
import ThumbnailContext from "./ThumbnailContext";
import {enableStackScrollSync, disableStackScrollSync} from "../../pages/StudyViewer/helpers/StackScrollSyncService";
import { getMetadataTagValue } from "../../pages/StudyViewer/helpers/CornerstoneService";
import {
  CALIBRATION_TOOL_NAME,
  requestCalibration,
} from "../../pages/StudyViewer/helpers/CalibrationService";
import { getAllThumbnailViewports } from "../../pages/StudyViewer/helpers/CornerstoneThumbnailService";
import { isMobile } from "react-device-detect";
import { loadAndCacheImage, loadImage } from "@cornerstonejs/core/loaders/imageLoader";
import userContext from "../users/UserContext";

const csToolsEvents = Enums.Events;

const ViewportState = (props) => {
  const {
    priorStudyData,
    reportDoneStatus,
    reportingDoctor,
    studyBoundingBox,
    studyData,
    setStudyBoundingBox,
    studyTextTool,
    viewportLoading,
    isGenki,
    studyParentId,
    parentChildReportsObj,
    alreadyAddedBB, setAlreadyAddedBB,
    hpDataList,
    appliedHp,
    setAppliedHp,
    setHpLoading,
    isHPApplied,
    setIsHpApplied,
    showPathologyOptions,
    hpPercentageMap, setHpPercentageMap,
    hpViewportMap, setHpViewportMap,
    setHpNotFound,
    maskImages, setMaskImages
  } = useContext(studyviewerContext);

  const {
    activeModality,
    activeThumbnailIndex,
    activeStudyId,
    setStackScrollActiveThumbnailIndex,
    changeActiveThumbnailIndex,
    setActiveModality,
    setActiveStudyId,
  } = useContext(ThumbnailContext);

  const {roles, username, userId} = useContext(userContext);

  const imageCacheRef = useRef(new Map());


  const [isUserInfoClicked, setIsUserInfoClicked] = useState(false);
  const { ref, setLoaderRunning } = useContext(loaderContext);
  const { showToastv2 } = useContext(toastContext);
  const [activeViewportIndex, setActiveViewportIndex] = useState(0);
  const [activeMPRViewportIndex, setActiveMPRViewportIndex] = useState(0);
  const [isAutoLoadLayout, setIsAutoLoadLayout] = useState(false);
  const [patientViewer, setPatientViewer] = useState(patientViewerState);
  const [testPatientViewerParent, setTestPatientViewerParent] = useState({});
  const [disableAddPathology, setDisableAddPathology] = useState(false);
  const [addedAnnotation, setAddedAnnotation] = useState([]);
  const [archivedPathology, setArchivedPathology] = useState(null);
  const [addedStoreAnnotation, setAddedStoreAnnotation] = useState([]);
  // Stable copy of the PARENT study's own lock-reference list, kept separate from
  // addedStoreAnnotation because that state gets repointed at whichever study
  // (including an unrelated child/prior study, e.g. a different-modality prior)
  // is currently active. The one-shot effect below that draws the parent's OWN
  // boxes can fire at an arbitrary point in time - whenever viewportLoading and
  // annotationAddedSuccess happen to both be true - which is NOT guaranteed to
  // coincide with addedStoreAnnotation actually pointing at the parent's data.
  // Using this dedicated, parent-only value keeps that call correct regardless
  // of which study the user most recently switched to.
  const [parentLockReference, setParentLockReference] = useState([]);
  const [contextMenuOpen, setContextMenuOpen] = useState({
    open: false,
    mouseEvt: null,
    data: null,
    showRemove: false,
  });
  const [allowAddingTextAnnotation, setAllowAddingTextAnnotation] =
    useState(false);
  const [showCompare, setShowCompare] = useState(false);
  const [isMPRActive, setIsMPRActive] = useState(false);
  const [isSagittalActive, setIsSagittalActive] = useState(false);
  const [isAxialActive, setIsAxialActive] = useState(false);
  const [isCoronalActive, setIsCoronalActive] = useState(false);
  const [is3DActive, setIs3DActive] = useState(false);
  const [isCompareActive, setIsCompareActive] = useState(false);
  const [showImpressions, setShowImpressions] = useState(false);
  const [boundingBox, setBoundingBox] = useState({});
  const [annotationData, setAnnotationData] = useState({});
  const [annotationDataAI, setAnnotationDataAI] = useState({});
  const [currentActiveTag, setCurrentActiveTag] = useState({
    id: undefined,
    color: undefined,
  });
  const [activeId, setActiveId] = useState("");
  const [isMPREnabled, setIsMPREnabled] = useState(true);
  const [activeColor, setActiveColor] = useState("");
  const [isMPRViewportActivate, setIsMPRViewportActivated] = useState(false);
  const [activeMPRTool, setActiveMPRTool] = useState("");
  const [previousActiveMPRTool, setPreviousActiveMPRTool] = useState("");
  const [viewportElements, setViewportElements] = useState([]);
  const [mprViewportElements, setMprViewportElements] = useState({});
  const [mprLoading, setMprLoading] = useState(true);
  const [mprSeriesData, setMprSeriesData] = useState({});
  let tempViewportElements = [];
  const [activeViewportModality, setActiveViewportModality] = useState("");
  const [viewportRow, setViewportRow] = useState(1);
  const [viewportColumn, setViewportColumn] = useState(1);
  const [activeTool, setActiveTool] = useState(DEFAULT_TOOL);
  const [previousActiveTool, setPreviousActiveTool] = useState();
  const [mouseButtonToolAssignments, setMouseButtonToolAssignments] =
    useState(loadMouseButtonToolAssignments);

  const assignMouseButtonToAssignableTool = useCallback((slot, toolName, forceAssign = false) => {
    if (!["primary", "secondary", "auxiliary"].includes(slot)) {
      return;
    }
    if (!MOUSE_ASSIGNABLE_TOOL_NAMES.includes(toolName)) {
      return;
    }
    setMouseButtonToolAssignments((prev) => {
      const next = { ...prev };
      if (!forceAssign && next[slot] === toolName) {
        next[slot] = null;
      } else {
        Object.keys(next).forEach((k) => {
          if (next[k] === toolName) {
            next[k] = null;
          }
        });
        next[slot] = toolName;
      }
      return next;
    });
  }, []);

  const togglePrimaryMouseAssignmentForTool = useCallback((toolName) => {
    const isCurrentlyPrimary =
      mouseButtonToolAssignments?.primary === toolName;

    if (isMPRActive) {
      setPreviousActiveMPRTool(activeMPRTool);
      if (isCurrentlyPrimary) {
        setActiveMPRTool(StackScrollTool.toolName);
        assignMouseButtonToAssignableTool("primary", StackScrollTool.toolName);
      } else {
        assignMouseButtonToAssignableTool("primary", toolName);
        setActiveMPRTool(toolName);
      }
      return;
    }

    if (isCurrentlyPrimary) {
      setActiveTool(StackScrollTool.toolName);
      assignMouseButtonToAssignableTool("primary", StackScrollTool.toolName);
    } else {
      assignMouseButtonToAssignableTool("primary", toolName);
      setActiveTool(toolName);
    }
  }, [
    assignMouseButtonToAssignableTool,
    isMPRActive,
    mouseButtonToolAssignments,
    activeMPRTool,
  ]);

  useEffect(() => {
    saveMouseButtonToolAssignments(mouseButtonToolAssignments);
  }, [mouseButtonToolAssignments]);
  const [showOverlay, setShowOverlay] = useState(true);
  const [volumeId, setVolumeId] = useState("");
  const [dragEvent, setDragEvent] = useState(false);
  const [thumbnailDropEvent, setThumbnailDropEvent] = useState(false);
  const [thumbnailClickEvent, setThumbnailClickEvent] = useState(false);
  const [allTextToolAnnotation, setAllTextToolAnnotation] = useState({});
  const [editWarning, setEditWarning] = useState({
    show: false,
    name: "",
    id: null,
    success: false,
    color: COLORS.warning,
  });

  const [maskingConfirm, setMaskingConfirm] = useState({
    show: false,
    name: "",
    id: null,
    success: false,
    color: COLORS.warning,
  });
  const [viewportSeriesData, setViewportSeriesData] = useState(() => {
    let array = [];
    for (let i = 0; i < VIEWPORT_COLUMN * VIEWPORT_ROW; i++) {
      array.push({ study: "", stack: "", modality: "" });
    }
    return array;
  });

  // Per-viewport "an image is actually rendered" flag, reported by each Viewport.
  // viewportSeriesData keeps its entry for viewports the layout unmounts (2x2 -> 1x1
  // -> 2x2 leaves them blank), so it can't be used to tell whether a slot has an image.
  const [viewportImageLoaded, setViewportImageLoaded] = useState({});

  const markViewportImageLoaded = useCallback((viewportIndex, loaded) => {
    setViewportImageLoaded((prev) =>
      prev[viewportIndex] === loaded ? prev : { ...prev, [viewportIndex]: loaded }
    );
  }, []);

  const [showPriorStudyTopBar, setShowPriorStudyTopBar] = useState(false);
  const [viewportStates, setViewportStates] = useState({});
  const [boundingBoxMode, setBoundingBoxMode] = useState(false);

  const [boundingBoxAdding, setBoundingBoxAdding] = useState(null);
  //   [
  //   { study: "", stack: "", modality: "" },
  //   { study: "", stack: "", modality: "" },
  //   { study: "", stack: "", modality: "" },
  //   { study: "", stack: "", modality: "" },
  // ]);
  const [isCineEnabled, setIsCineEnabled] = useState(false);
  const [isMPRCineEnabled, setIsMPRCineEnabled] = useState(false);
  const [isSynchronizedEnabled, setIsSynchronizedEnabled] = useState(false);
  const [syncMode, setSyncMode] = useState(SYNC_MODES.AUTOMATIC);
  const [linkedViewports, setLinkedViewports] = useState([]);
  const [isReferenceLinesEnabled, setIsReferenceLinesEnabled] = useState(false);
  const [annotationAddedSuccess, setAnnotationAddedSuccess] = useState(false);
  const [isChildStudyActive, setIsChildStudyActive] = useState(false);
  const [isReferenceLineActivated, setIsReferenceLineActivated] =
    useState(false);
  const [viewportLoadingComplete, setViewportLoadingComplete] =
    useState(false);
  const [mprViewportLoaderRunning, setMPRViewportLoaderRunning] =
    useState(true);
  const addedEvt = csToolsEvents.ANNOTATION_ADDED;
  const completedEvt = csToolsEvents.ANNOTATION_COMPLETED;
  const updatedEvt = csToolsEvents.ANNOTATION_MODIFIED;
  const [imageLoadedOnViewport, setImageLoadedOnViewport] = useState(false);
  const [isScrollingUp, setIsScrollingUp] = useState(false);
  const [isSeriesScrollEnabled, setIsSeriesScrollEnabled] = useState(true);
  const [viewportHpLayout, setViewportHpLayout] = useState(new Map());
  const [viewportHpImage, setViewportHpImage] = useState(new Map());
  const [viewportOldState, setViewportOldState] = useState({
    viewportIndex: 1,
    isDoubleClicked: false,
    largeImage: false,
    reportMenu: null,
    seriesMenu: null,
    showPathologyOptions: showPathologyOptions,
    viewportRow: viewportRow,
    viewportColumn: viewportColumn,
    loadOldViewportStatus: false,
  });

  const [viewportDoubleClickIndex, setViewportDoubleClickIndex] = useState(-1);
  const [viewportDoubleClickIndexConst, setViewportDoubleClickIndexConst] = useState(-1); 

  const [isSrSelected, setIsSrSelected] = useState(false);
  
  const [hPThumbnailIds, setHPThumbnailIds] = useState([]);

  const[isCropEnable , setIsCropEnable] = useState(false);

  const getViewportProperties = (viewport, scale, voi) => ({
    properties : viewport.getProperties() || null,
    camera : viewport.getCamera() || null,
    actor : viewport.getActor() || null,
    actors : viewport.getActors() || null,
    imageData : viewport.getImageData() || null,
    currentImageIndex : viewport.getCurrentImageIdIndex() || null,
  });


  const updateViewportProperties = (viewportIndex, viewportInstance, scale, voi) => {
    if(viewportInstance){
      const properties = getViewportProperties(viewportInstance, scale, voi);

      setViewportStates((prevStates) => ({
        ...prevStates,
        [viewportIndex]: {
          ...prevStates[viewportIndex],
          ...properties,
        },
      }));
    }
  };


  useEffect(() => {
    if (activeStudyId == studyParentId) {
      setIsChildStudyActive(false);
    } else {
      setIsChildStudyActive(true);
    }
    if (Object.keys(parentChildReportsObj)?.length > 0) {
      if (
        showPathologyForModalities.includes(
          parentChildReportsObj[activeStudyId]?.modality
        )
      ) {
        setShowPriorStudyTopBar(true);
      } else {
        setShowPriorStudyTopBar(false);
      }
    }
    // parentChildReportsObj is populated by the same initial study-structure
    // response that also drives activeStudyId's first update (e.g. auto-loading
    // the first series). Depending on network timing, activeStudyId can change
    // before parentChildReportsObj has committed, in which case the guard above
    // skips setting showPriorStudyTopBar entirely and it's left holding whatever
    // it was before - producing the "sometimes shown, sometimes hidden" panel
    // flakiness. Re-running this effect once parentChildReportsObj actually
    // arrives re-evaluates the same activeStudyId against the now-available data.
  }, [activeStudyId, parentChildReportsObj]);

  useEffect(() => {
    if (
      viewportLoading.viewport1Loading == true ||
      viewportLoading.viewport2Loading == true ||
      viewportLoading.viewport3Loading == true ||
      viewportLoading.viewport4Loading == true
    ) {
      if (
        annotationAddedSuccess == true &&
        Object.keys(annotationData).length == 0
      ) {
        if (studyBoundingBox.length > 0) {
          // Explicitly pass the parent's own lock reference rather than letting
          // addBoundingBoxToViewport default to addedStoreAnnotation - by the time
          // this one-shot fires, addedStoreAnnotation may already be repointed at
          // a different (e.g. child/prior) study the user switched to in the meantime.
          addBoundingBoxToViewport(studyBoundingBox, false, parentLockReference);
        }
      }
    }
  }, [viewportLoading, annotationAddedSuccess]);

  useEffect(() => {
    if (allowAddingTextAnnotation) {
      if (studyTextTool.length > 0) {
        setTimeout(() => {
          addTextAnnotationToViewport(studyTextTool);
        }, 1000);
      }
    }
  }, [allowAddingTextAnnotation]);

  const addMeasurement = (csToolsEvent, id, name, color) => {
    try {
      const annotationAddedEventDetail = csToolsEvent.detail;
      if (annotationAddedEventDetail != undefined) {
        setEditWarning(() => {
          let newVal = { ...editWarning };
          newVal.show = true;
          newVal.name = "Marking " + name;
          newVal.success = true;
          newVal.color = color;
          newVal.id = id;
          return newVal;
        });
        const {
          annotation: { metadata, annotationUID },
        } = annotationAddedEventDetail;
        const { toolName } = metadata;
        if (id != "")
          annotationToMeasurement(
            toolName,
            annotationAddedEventDetail,
            id,
            color
          );
        
      } 
    } catch (error) {
      console.warn("Failed to update measurement:", error);
    }
  };

  useEffect(() => {
    eventBus.on("contextMenuAdd", (evtData) => {
      setContextMenuOpen(() => {
        const newVal = { ...contextMenuOpen };
        newVal.open = evtData.show;
        newVal.mouseEvt = evtData.mouseEvent;
        newVal.data = evtData.data;
        newVal.showRemove = evtData.showRemove;
        return newVal;
      });
    });
  }, []);

  const extractImageUrl = (s) => {
    const match = s.match(/\/get\/\d+\/(.+)/);
    return match ? match[1] : null;
  };

  const annotationToMeasurement = (
    source,
    sourceAnnotationDetail,
    id,
    color,
    isUpdate = false
  ) => {
    if (source == "RectangleROI") {
      const activeViewport = getViewportByIdAndRenderingEngine(sourceAnnotationDetail.viewportId, sourceAnnotationDetail.renderingEngineId);

      let imageURL = activeViewport.getCurrentImageId();
      imageURL = extractImageUrl(imageURL);

      let boundingBoxTemp = annotationData;
      if (!boundingBoxTemp[imageURL]) {
        boundingBoxTemp[imageURL] = {};
      }
      if (!boundingBoxTemp[imageURL][id]) {
        boundingBoxTemp[imageURL][id] = [];
      }
      boundingBoxTemp[imageURL][id].push(sourceAnnotationDetail);
      handleColorChange(id, color, boundingBoxTemp[imageURL]);
      setDisableAddPathology(false);

    }
  };

  const restoreBoundingBox = async (studyBoundingBox, pathologyId) => {
    handleRemoveWarning();
   
    const activeViewport = await getViewport(activeViewportIndex);
    let isRender = false;
    let imageURL = activeViewport.getCurrentImageId();
    imageURL = extractImageUrl(imageURL);
    for (let imageURLVar in annotationData) {
      if(imageURLVar == imageURL) {
        for (let pathId in annotationData[imageURLVar]) {
          if (pathId == pathologyId) {
            annotationData[imageURLVar][pathId].forEach((item) => {
              let annotationUID = item.annotation.annotationUID;
              annotation.state.removeAnnotation(annotationUID);
              isRender = true;
            });
          }
        }
      }
    }
    
    annotationData[imageURL][pathologyId] = [];

     for (let imageURLVar in annotationDataAI) {
      if(imageURLVar == imageURL) {
        for (let pathId in annotationDataAI[imageURLVar]) {
          if (pathId == pathologyId) {
            annotationDataAI[imageURLVar][pathId].forEach((item) => {
              let annotation_obj = JSON.parse(JSON.stringify(item));
              annotation.state.addAnnotation(annotation_obj.annotation);
              annotationData[imageURL][pathologyId].push(annotation_obj);
              isRender = true;
            });
          }
        }
      }
    }
    activeViewport.render();
  };

  const addTextAnnotationToDatabase = async (textAnnotationObject, addOrUpdate) => {
    const activeViewport = await getViewport(activeViewportIndex);
    let imageURL = activeViewport.getCurrentImageId();
    imageURL = extractImageUrl(imageURL);

    const { imageData } = activeViewport.getImageData();
    let boundingBoxTemp = allTextToolAnnotation;
    if (!boundingBoxTemp[imageURL]) {
      boundingBoxTemp[imageURL] = [];
    }

    setTimeout(() => {

      let start = imageData.worldToIndex(
        textAnnotationObject.data.handles.points[0]
      );
    let end = imageData.worldToIndex(
      textAnnotationObject.data.handles.points[1]
    );
  let worldPos = imageData.worldToIndex(
    textAnnotationObject.data.handles.textBox.worldPosition
    );
    let topLeft = imageData.worldToIndex(
      textAnnotationObject.data.handles.textBox.worldBoundingBox.topLeft
    );
    let topRight = imageData.worldToIndex(
      textAnnotationObject.data.handles.textBox.worldBoundingBox.topRight
    );
    let bottomLeft = imageData.worldToIndex(
      textAnnotationObject.data.handles.textBox.worldBoundingBox.bottomLeft
    );
    let bottomRight = imageData.worldToIndex(
      textAnnotationObject.data.handles.textBox.worldBoundingBox.bottomRight
    );
  
  let height = Math.abs(bottomLeft[1] - topLeft[1]);
    let width = Math.abs(topRight[0] - topLeft[0]);

    let top = topLeft[1];
    let left = topLeft[0];

    const boundingBox = { height, width, top, left };
    const annotationUID = textAnnotationObject.annotationUID;
    const cameraFocalPoint = textAnnotationObject.metadata.cameraFocalPoint;
    const sliceIndex = textAnnotationObject.metadata.sliceIndex;
    const cachedStats = textAnnotationObject.data.cachedStats;

    const text = textAnnotationObject.data.text;
    const arrowFirst = textAnnotationObject.data.handles.arrowFirst;
    const obj = { start, end, text, worldPos, boundingBox, annotationUID, cameraFocalPoint, sliceIndex, cachedStats, arrowFirst };

    const updatedJsonFormate = getTextAnnotationLegacyData(obj);
    const serialized = JSON.stringify(updatedJsonFormate);
    const existingIndex = boundingBoxTemp[imageURL].findIndex(item => {
      try { return JSON.parse(item).annotationUID === annotationUID; } catch { return false; }
    });

    if(addOrUpdate){
      // Guard against duplicate when ANNOTATION_MODIFIED's upsert already inserted it
      if (existingIndex === -1) {
        boundingBoxTemp[imageURL].push(serialized);
      } else {
        boundingBoxTemp[imageURL][existingIndex] = serialized;
      }
    }else{
      if (existingIndex !== -1) {
        boundingBoxTemp[imageURL][existingIndex] = serialized;
      } else {
        // ANNOTATION_MODIFIED fired before ANNOTATION_COMPLETED's timeout — upsert
        boundingBoxTemp[imageURL].push(serialized);
      }
    }
    
    setAllTextToolAnnotation(boundingBoxTemp);
  },10)
  };

  const addTextAnnotationFromDatabaseToViewport = async (
    imageURL,
    e,
    tempTextAnnotationData
  ) => {
    // let obj = JSON.parse(e);

    annotation.state.addAnnotation(e);

    let boundingBoxTemp = allTextToolAnnotation;
    if (!boundingBoxTemp[imageURL]) {
      boundingBoxTemp[imageURL] = [];
    }
    boundingBoxTemp[imageURL].push(tempTextAnnotationData);
    setAllTextToolAnnotation(boundingBoxTemp);
  };

  const updateBBPosition = async(studyBoundingBox, runUpdate, showBB, pathId ) => {
    const activeViewport = await getViewport(activeViewportIndex);
    
    if (activeViewport != null || activeViewport != undefined) {
      studyBoundingBox.map((ele) => {
        var imageURL = ele.imageUrl;


        const dicomBaseURL = API_BASE_URL.startsWith("https")
          ? API_BASE_URL.replace("https", "wadouri") +
            APIs.GETIMAGEDATAWITHFILESIZE + ele.imageId + "/" +
            imageURL
          : API_BASE_URL.replace("http", "wadouri") +
            APIs.GETIMAGEDATAWITHFILESIZE + ele.imageId + "/" +
            imageURL;
        ele?.annotationMeasurements.map((ele, index) => {
          if(((pathId == null || pathId == undefined) && (annotationData[imageURL] != undefined && annotationData[imageURL][ele.id] != undefined)) || ele.id === pathId){   
            const { imageData, dimensions } = activeViewport?.getImageData();
            // let jsonDataBoundingBox = JSON.parse(ele.measurementData);
            let allFourPoints = getAllFourCoordinates(
              JSON.parse(ele.measurementData)
            );

            let updatedPoints = [];
            updatedPoints.push(imageData.indexToWorld(allFourPoints[0]));
            updatedPoints.push(imageData.indexToWorld(allFourPoints[1]));
            updatedPoints.push(imageData.indexToWorld(allFourPoints[2]));
            updatedPoints.push(imageData.indexToWorld(allFourPoints[3]));

            let newBoundingBox = getUpdatedJson(
              dicomBaseURL,
              updatedPoints,
              JSON.parse(ele.measurementData).annotationUID
            );
            if (showBB != undefined) {
              if(showBB != undefined){
                newBoundingBox.annotation.isVisible = showBB;
              }
            }else{
              newBoundingBox.annotation.isVisible = annotationData[imageURL] != undefined && annotationData[imageURL][ele.id] != undefined ? true : false;
            }
            
            const annotationVisibility = newBoundingBox.annotation.isVisible;
            const annotationUID = annotation.state.addAnnotation(newBoundingBox.annotation);
            annotation.visibility.setAnnotationVisibility(annotationUID, annotationVisibility);
            
            toolStyle.setAnnotationStyles(newBoundingBox.annotation.annotationUID, {
              lineWidth: "2px",
              textBoxLinkLineWidth: "0",
              textBoxFontSize: "0px",
              color: ele.color,
              colorSelected: ele.color,
              colorHighlighted: ele.color,
            });
          }
        });
        activeViewport.render();
      });
    }
   
  }

  const addBoundingBoxToViewport = async (
    studyBoundingBox,
    forceSync = false,
    lockReferenceList = addedStoreAnnotation
  ) => {
    // `manualData`/`manualDataAI` are the SAME object references as the annotationData/
    // annotationDataAI state. We track live annotation objects directly into them (rather than
    // building a JSON-cloned copy and setState-ing that in) so that later drags/resizes of these
    // boxes - which Cornerstone applies in place on the live annotation object - are visible when
    // the report is saved/submitted (see reformateBoundingBox in StudyReportState.jsx).
    let manualData = annotationData;
    let manualDataAI = annotationDataAI;
    const activeViewport = await getViewport(activeViewportIndex);
    let unlockedAnnotation = [];
    if (activeViewport != null || activeViewport != undefined) {
      studyBoundingBox.map((ele) => {
        var imageURL = ele.imageUrl;

        if (lockReferenceList.length > 0) {
          lockReferenceList.map((ele) => {
            // An AI-predicted tag counts as "locked" (visible) only if is_locked or
            // is_annotated was explicitly set true. Some paths (e.g. a supervisor
            // reviewing a study whose generateAnnotationsToDisplay branch never
            // touches these fields for an unselected AI prediction) leave them
            // undefined - treat that the same as false rather than letting an
            // unconfirmed smart tag default to visible.
            if (
              ele.ai_predicted == 1 &&
              ele.is_locked !== true &&
              ele.is_annotated !== true
            ) {
              unlockedAnnotation.push(ele.id);
            }
          });
        }

        const dicomBaseURL = API_BASE_URL.startsWith("https")
          ? API_BASE_URL.replace("https", "wadouri") +
            APIs.GETIMAGEDATAWITHFILESIZE + ele.imageId + "/" +
            imageURL
          : API_BASE_URL.replace("http", "wadouri") +
            APIs.GETIMAGEDATAWITHFILESIZE + ele.imageId + "/" +
            imageURL;
        ele?.annotationMeasurements.map((ele, index) => {
          const viewportImageData = activeViewport?.getImageData();
          if (!viewportImageData) return;
          const { imageData, dimensions } = viewportImageData;
          // let jsonDataBoundingBox = JSON.parse(ele.measurementData);
          let allFourPoints = getAllFourCoordinates(
            JSON.parse(ele.measurementData)
          );

          let updatedPoints = [];
          updatedPoints.push(imageData.indexToWorld(allFourPoints[0]));
          updatedPoints.push(imageData.indexToWorld(allFourPoints[1]));
          updatedPoints.push(imageData.indexToWorld(allFourPoints[2]));
          updatedPoints.push(imageData.indexToWorld(allFourPoints[3]));

          let newBoundingBox = getUpdatedJson(
            dicomBaseURL,
            updatedPoints,
            JSON.parse(ele.measurementData).annotationUID
          );
          const visible = !unlockedAnnotation.includes(ele.id);
          const targetBucket = visible ? manualData : manualDataAI;
          let flag = true;
          if (ele.id != undefined && targetBucket[imageURL]?.[ele.id]?.length > 0) {
            targetBucket[imageURL][ele.id].map((item, index) => {
              if (
                item.annotation.annotationUID ==
                newBoundingBox.annotation.annotationUID
              ) {
                flag = false;
                return;
              }
            });
          }
          if (!visible) {
            newBoundingBox.annotation.isVisible = false;
          }
          addToViewport(
            newBoundingBox,
            ele.id,
            ele.color,
            dicomBaseURL,
            manualData,
            visible,
            manualDataAI,
            flag
          );

          // Keep a restore-source copy in the AI bucket even when the pathology is already
          // locked/selected at load time (e.g. reopening a previously submitted study) -
          // otherwise deselecting and reselecting the AI tag later has nothing to restore from.
          if (visible) {
            const alreadyInAIBucket = manualDataAI[imageURL]?.[ele.id]?.some(
              (item) =>
                item.annotation.annotationUID ===
                newBoundingBox.annotation.annotationUID
            );
            if (!alreadyInAIBucket) {
              annotationToMeasurementTemp(
                "RectangleROI",
                newBoundingBox,
                ele.id,
                ele.color,
                dicomBaseURL,
                manualDataAI
              );
            }
          }
        });
      });
      if(!alreadyAddedBB || forceSync){
        // Shallow-copy the top-level container so React sees a new reference and re-renders;
        // the nested per-pathology arrays/annotation objects keep their live identity.
        // forceSync lets a later call (e.g. drawing a *different* prior/child study's own
        // boxes after the first study already tripped alreadyAddedBB) still sync React state,
        // without disturbing the original single-study one-shot behavior for existing callers.
        setAnnotationDataAI({ ...manualDataAI });
        setAnnotationData({ ...manualData });
        setAlreadyAddedBB(true);
      setTimeout(() => {
        setActiveTool("RectangleROI");
      }, 500);
      setTimeout(() => {
        setPreviousActiveTool("RectangleROI");
        // setActiveTool(StackScrollTool.toolName);
        handleDefaultToolChange();
      }, 600);
      }
    }
  };

  const addTextAnnotationToViewport = async (studyTextTool) => {
    const activeViewport = await getViewport(activeViewportIndex);
    if (activeViewport != null || activeViewport != undefined) {
      const { imageData, dimensions } = activeViewport?.getImageData();

      studyTextTool.map((ele) => {
        var imageURL = ele.imageUrl;
        ele?.annotationMeasurements.map((ele, index) => {
          const tempTextAnnotationData = JSON.parse(ele.measurementData);
          const { viewPlaneNormal, viewUp } = activeViewport.getCamera();
          const start = imageData.indexToWorld([
            tempTextAnnotationData?.handles?.start.x,
            tempTextAnnotationData?.handles?.start.y,
            0,
          ]);
          const end = imageData.indexToWorld([
            tempTextAnnotationData?.handles?.end.x,
            tempTextAnnotationData?.handles?.end.y,
            0,
          ]);
          const worldPosition = imageData.indexToWorld([
            tempTextAnnotationData.handles?.textBox.x,
            tempTextAnnotationData.handles?.textBox.y,
            0,
          ]);
          let top = tempTextAnnotationData?.handles?.textBox.boundingBox.top;
          let left = tempTextAnnotationData?.handles?.textBox.boundingBox.left;
          let height =
            tempTextAnnotationData?.handles?.textBox?.boundingBox.height;
          let width =
            tempTextAnnotationData?.handles?.textBox.boundingBox.width;

          const topLeft = imageData.indexToWorld([left, top, 0]);
          const topRight = imageData.indexToWorld([left + width, top, 0]);
          const bottomLeft = imageData.indexToWorld([left, top + height, 0]);
          const bottomRight = imageData.indexToWorld([
            left + width,
            top + height,
            0,
          ]);
          const text = tempTextAnnotationData.text;
          const annotationUID = tempTextAnnotationData.annotationUID
            ? tempTextAnnotationData.annotationUID
            : uuidv4();
          if (!tempTextAnnotationData.annotationUID) {
            tempTextAnnotationData["annotationUID"] = uuidv4();
            ele.measurementData = JSON.stringify(tempTextAnnotationData);
          }
          const cameraFocalPoint = tempTextAnnotationData.cameraFocalPoint;
          const sliceIndex = tempTextAnnotationData.sliceIndex;
          const cachedStats = tempTextAnnotationData.cachedStats;
          const arrowFirst = tempTextAnnotationData.arrowFirst;
          const finalUrl = (isGenki && imageURL.endsWith('.png') ? imageBaseURL : dicomWebURL) + imageURL;
          const updatedAnnotationJson = getTextAnnotation3DObject(
            viewPlaneNormal,
            viewUp,
            activeViewport.getFrameOfReferenceUID(),
            finalUrl,
            start,
            end,
            worldPosition,
            topLeft,
            topRight,
            bottomLeft,
            bottomRight,
            text,
            annotationUID,
            cameraFocalPoint, 
            sliceIndex, 
            cachedStats,
            arrowFirst
          );
          if (annotationUID != undefined) {
            addTextAnnotationFromDatabaseToViewport(
              imageURL,
              updatedAnnotationJson,
              ele.measurementData
            );
          }
        });
      });

      setTimeout(() => {
        setActiveTool("ArrowAnnotate");
      }, 200);
      setTimeout(() => {
        setPreviousActiveTool("ArrowAnnotate");
        setActiveTool(StackScrollTool.toolName);
      }, 300);
    }
  };

  const addToViewport = (
    jsonParsed,
    id,
    color,
    imageURL,
    manualData,
    visible,
    manualDataAI,
    shouldTrack = true
  ) => {

    // Add annotation
    const annotationUID = annotation.state.addAnnotation(jsonParsed.annotation);
    annotation.visibility.setAnnotationVisibility(annotationUID, visible);

    toolStyle.setAnnotationStyles(jsonParsed.annotation.annotationUID, {
      lineWidth: "2px",
      textBoxLinkLineWidth: "0",
      textBoxFontSize: "0px",
      color: color,
      colorSelected: color,
      colorHighlighted: color,
    });
    // Track the live annotation reference in the matching bucket (locked vs AI-suggested) so
    // later edits - and locking an AI suggestion via handleRemovingAndAddingOfBB - stay linked
    // to the object Cornerstone actually mutates.
    if (shouldTrack)
      annotationToMeasurementTemp(
        "RectangleROI",
        jsonParsed,
        id,
        color,
        imageURL,
        visible ? manualData : manualDataAI
      );

    resizeViewport();
  };

  const annotationToMeasurementTemp = (
    source,
    sourceAnnotationDetail,
    id,
    color,
    imageURL,
    manualData
  ) => {
    if (source == "RectangleROI") {
      imageURL = extractImageUrl(imageURL);
      let boundingBoxTemp = manualData;
      if (!boundingBoxTemp[imageURL]) {
        boundingBoxTemp[imageURL] = {};
      }
      if (!boundingBoxTemp[imageURL][id]) {
        boundingBoxTemp[imageURL][id] = [];
      }
      boundingBoxTemp[imageURL][id].push(sourceAnnotationDetail);
      toolStyle.setAnnotationStyles(
        sourceAnnotationDetail.annotation.annotationUID,
        {
          lineWidth: "2px",
          textBoxLinkLineWidth: "0",
          textBoxFontSize: "0px",
          color: color,
          colorSelected: color,
          colorHighlighted: color,
        }
      );
    }
  };

  const handleColorChange = (valId, valColor, data) => {
    data[valId].forEach((item) => {
      toolStyle.setAnnotationStyles(item.annotation.annotationUID, {
        lineWidth: "2px",
        textBoxLinkLineWidth: "0",
        textBoxFontSize: "0px",
        color: valColor,
        colorSelected: valColor,
        colorHighlighted: valColor,
      });
    });
  };

  const checkIfTextAnnotationExists = (annotationUID) => {
    for (const key in allTextToolAnnotation) {
      allTextToolAnnotation[key].map((item) => {
        const obj = JSON.parse(item);
        if (obj.annotationUID === annotationUID) {
          return false;
        }
      });
    }
    return true;
  };

  const disableMasking = (changeToDefault = true)=>{
    setIsCropEnable(false);
    setMaskingConfirm(() => {
      let newVal = { ...maskingConfirm };
      newVal.show = false;
      return newVal;
    });
      setPreviousActiveTool(activeTool);

    if(changeToDefault){    
      handleDefaultToolChange();
    }
 
  }
 function getUpdatedMaskImages(prevMaskImages, annotationUID) {
  let didChange = false;
  let changedImageId = null;
  const updatedEntries = 
    Object.entries(prevMaskImages).map( ([id, mask]) => {
      const filteredAnnotations = mask.maskAnnotationData.filter(
        a => a.annotationUID !== annotationUID
      );
      if (filteredAnnotations.length !== mask.maskAnnotationData.length) {
        didChange = true;
        changedImageId = id;
        return [id, { ...mask, maskAnnotationData: filteredAnnotations }];
      }
      
      return [id, mask];
    })
    
  
  const updatedMaskImages = Object.fromEntries(updatedEntries);
  return { updatedMaskImages, changedImageId };
}

const removeCropAnnotaionData = async (annotationUID) => {
  const { updatedMaskImages, changedImageId } =  getUpdatedMaskImages(maskImages, annotationUID);
  
  if (changedImageId != null) {
     renderViewports();
  }
  setMaskImages(updatedMaskImages);
};

  
  

  useEffect(() => {
    eventTarget.addEventListener(completedEvt, async (e) => {
      let toolName = e.detail.annotation.metadata.toolName;

      if (toolName === CALIBRATION_TOOL_NAME) {
        // Calibration draw finished: open the Calibration dialog to ask for the
        // real distance (the line stays visible meanwhile), and return to the
        // default tool so the user isn't stuck drawing more lines.
        requestCalibration(e.detail.annotation);
        setPreviousActiveTool(CALIBRATION_TOOL_NAME);
        setActiveTool(StackScrollTool.toolName);
        return;
      }

      if (
        toolName == "ArrowAnnotate" &&
        checkIfTextAnnotationExists(e.detail.annotation.annotationUID)
      ) {
        addTextAnnotationToDatabase(e.detail.annotation,true);

      }
    });

    eventTarget.addEventListener(updatedEvt, (e) => {
      let toolName = e.detail.annotation.metadata.toolName;
      if (
        toolName == "ArrowAnnotate" &&
        checkIfTextAnnotationExists(e.detail.annotation.annotationUID)
      ) {
        addTextAnnotationToDatabase(e.detail.annotation,false);
      }
    });
  }, []);

  const boundingBoxModeRef = useRef(boundingBoxMode);
  const activePathologyRef = useRef(null);
  const activeMaskingProfileRef = useRef(null);
  const addEvtCallbackRef = useRef(null);
  useEffect(() => {
    boundingBoxModeRef.current = boundingBoxMode;
    if(!boundingBoxMode) {
      activePathologyRef.current = {
        id: "",
        backgroundColor: "",
        pathologyName: "",
      };
      removeWarning();
    }
  }, [boundingBoxMode]);

  const handlePencilClick = (data, toolName) => {

    activePathologyRef.current = {
      id: data.id,
      backgroundColor: data.backgroundColor,
      pathologyName: data.pathalogyName,
    };
    hideBoundingBox(data.id, false);

    // Remove the previous listener using the stored reference so it is actually removed
    if (addEvtCallbackRef.current) {
      eventTarget.removeEventListener(addedEvt, addEvtCallbackRef.current);
    }

    const addEvtCallback = (e) => {
      if(!boundingBoxModeRef.current)
        return;
      setBoundingBoxAdding("enabled");
      if(viewportSeriesData[e.detail.viewportId.slice(-1)].study != studyParentId) {
        const id = e.detail.annotation.annotationUID;
        removeAnnotation(id);

      } else {
        addMeasurement(e, activePathologyRef.current.id, activePathologyRef.current.pathologyName, activePathologyRef.current.backgroundColor);
      }

    };
    addEvtCallbackRef.current = addEvtCallback;
    eventTarget.addEventListener(addedEvt, addEvtCallback);
  };

  const hideBoundingBox = async (id, hide) => {
    // if(boundingBoxMode)
    //   setBoundingBoxMode(false);
    const activeViewport = await getViewport(activeViewportIndex);
    let imageURL = activeViewport.getCurrentImageId();
    imageURL = extractImageUrl(imageURL);
    let boundingBoxTemp = annotationData[imageURL];

    if (
      boundingBoxTemp != undefined &&
      activeViewport?.element != undefined &&
      boundingBoxTemp[id] != undefined
    ) {
      boundingBoxTemp[id].forEach((item) => {
        annotation.visibility.setAnnotationVisibility(item.annotation.annotationUID, !hide);
      });

      renderViewports();
    }
  };

  const removeBB = (id) => {
    let isRender = false;
    for (let imageURLVar in annotationData) {
      for (let pathId in annotationData[imageURLVar]) {
        if (pathId == id) {
          annotationData[imageURLVar][id].forEach((item) => {
            let annotationUID = item.annotation.annotationUID;
            annotation.state.removeAnnotation(annotationUID);
            isRender = true;
          });
        }
      }
    }
    if(isRender)
      renderViewports();
  }

  const addAiBb = (id) => {
    let isRender = false;
    for (let imageURLVar in annotationDataAI) {
      for (let pathId in annotationDataAI[imageURLVar]) {
        if (pathId == id) {
          annotationDataAI[imageURLVar][id].forEach((item) => {
            let bb =  JSON.parse(JSON.stringify(item.annotation));
            annotation.state.addAnnotation(bb);
            isRender = true;
          });
        }
      }
    }
    if(isRender)
      renderViewports();
  };

  const changeAiBbVisibility = (id, isVisible) => {
    let isRender = false;
    for (let imageURLVar in annotationDataAI) {
      for (let pathId in annotationDataAI[imageURLVar]) {
        if (pathId == id) {
          if(annotationDataAI[imageURLVar][id]) {
            annotationDataAI[imageURLVar][id].forEach((item) => {
              const annotationUID = item.annotation.annotationUID;
              if(annotation.state.getAnnotation(annotationUID)) {
                annotation.visibility.setAnnotationVisibility(annotationUID, isVisible);
                isRender = true;
              }
            });
          }
        }
      }
    }
    if(isRender)
      renderViewports();
  };

  const handleRemovingAndAddingOfBB = (transferFromAIData, imageURL, id) => {
      if(transferFromAIData){
        // Keep the live annotation reference (no clone) so edits made after locking this
        // AI-suggested pathology stay linked to the object Cornerstone actually mutates.
        let toTransfer = annotationDataAI[imageURL][id];
        if (imageURL != "") {
          if (!annotationData[imageURL]) {
            annotationData[imageURL] = [];
          }
          if (
            !annotationData[imageURL][id] ||
            annotationData[imageURL][id].length >= 0
          ) {
            annotationData[imageURL][id] = toTransfer;
          }
        }
      }else{
          setAnnotationData((prevState) => {
            const newState = { ...prevState };
            const { [id]: _, ...rest } = newState[imageURL];
            newState[imageURL] = rest;
            return newState;
          });
      }
  }

  const addLockedAIPathology = (id, addOrRemove) => {
    let imageURL = "";
    let render = false;
    if (addOrRemove) {
      for (let imageURLVar in annotationDataAI) {
        for (let pathId in annotationDataAI[imageURLVar]) {
          if (pathId == id) {
            imageURL = imageURLVar;
            handleRemovingAndAddingOfBB(true, imageURLVar, id);
            break;
          }
        }
      }
    } else {
      for (let imageURLVar in annotationData) {
        for (let pathId in annotationData[imageURLVar]) {
          if (pathId == id) {
            annotationData[imageURLVar][pathId].map((item) => {
              if (item != null || item != undefined) {
                annotation.state.removeAnnotation(item.annotation.annotationUID);
                render =  true;
              }
            });
            handleRemovingAndAddingOfBB(false, imageURLVar, id);
            break;
          }
        }
      }
      for (let imageURLVar in annotationDataAI) {
        for (let pathId in annotationDataAI[imageURLVar]) {
          if (pathId == id) {
            annotationDataAI[imageURLVar][pathId].map((item) => {
              if (item) {
                const bb = JSON.parse(JSON.stringify(item.annotation));
                annotation.state.addAnnotation(bb);
                render = true;
              }
            });
            break;
          }
        }
      }
    }
    if(render)
      renderViewports();
    return true;
  };

  const handleChangeLabelForTextAnnotation = (annotationVal) => {
    setContextMenuOpen(() => {
      const newVal = { ...contextMenuOpen };
      newVal.open = false;
      newVal.mouseEvt = null;
      newVal.data = null;
      return newVal;
    });
    for (const key in allTextToolAnnotation) {
      allTextToolAnnotation[key].map((item) => {
        const obj = JSON.parse(item);
        if (obj.annotationUID === annotationVal.annotationUID) {
          let measurement = annotation.state.getAnnotation(
            annotationVal.annotationUID
          );
          const userInput = window.prompt("Change Label: ");

          if (userInput !== null) {
            measurement.data.text = userInput;
            updateTextInSavedTextAnnotation(
              measurement.metadata.referencedImageId,
              annotationVal.annotationUID,
              userInput
            );
          }
        }
      });
    }
    return true;
  };

  const updateTextInSavedTextAnnotation = (imageURL, annotationUID, text) => {
    const annotationDataTemp = { ...allTextToolAnnotation };
    imageURL = extractImageUrl(imageURL);

    if (annotationDataTemp[imageURL]) {
      // Use map to update the text property
      annotationDataTemp[imageURL] = annotationDataTemp[imageURL].map(
        (item) => {
          const parseJSON = JSON.parse(item);
          if (parseJSON.annotationUID === annotationUID) {
            parseJSON.text = text;
          }
          return JSON.stringify(parseJSON);
        }
      );
    }
    setAllTextToolAnnotation(annotationDataTemp);
  };

  const handleRemoveBoundingBox = (annotationVal) => {
    let imageURL = annotationVal.metadata.referencedImageId;
    annotation.state.removeAnnotation(annotationVal.annotationUID);
    removeBoundingBoxFromObject(imageURL, annotationVal.annotationUID);
    removeCropAnnotaionData(annotationVal.annotationUID);
    setContextMenuOpen(() => {
      const newVal = { ...contextMenuOpen };
      newVal.open = false;
      newVal.mouseEvt = null;
      newVal.data = null;
      return newVal;
    });
    renderViewports();
  };

  const collectProtectedAnnotationUIDs = () => {
    const protectedUIDs = new Set();

    Object.values(annotationData || {}).forEach((imageEntry) => {
      Object.values(imageEntry || {}).forEach((annotations = []) => {
        annotations.forEach((item) => {
          const uid = item?.annotation?.annotationUID;
          if (uid) {
            protectedUIDs.add(uid);
          }
        });
      });
    });

    Object.values(annotationDataAI || {}).forEach((imageEntry) => {
      Object.values(imageEntry || {}).forEach((annotations = []) => {
        annotations.forEach((item) => {
          const uid = item?.annotation?.annotationUID;
          if (uid) {
            protectedUIDs.add(uid);
          }
        });
      });
    });

    Object.values(maskImages || {}).forEach((maskEntry) => {
      (maskEntry?.maskAnnotationData || []).forEach((item) => {
        const uid = item?.annotationUID;
        if (uid) {
          protectedUIDs.add(uid);
        }
      });
    });

    return protectedUIDs;
  };

  const removeAnnotationByUID = (annotationUID) => {
    const annotationObj = annotation.state.getAnnotation(annotationUID);
    if (!annotationObj) {
      return false;
    }

    const referencedImageId = annotationObj?.metadata?.referencedImageId;
    const toolName = annotationObj?.metadata?.toolName;

    annotation.state.removeAnnotation(annotationUID);

    if (referencedImageId) {
      removeBoundingBoxFromObject(referencedImageId, annotationUID);
      removeTextAnnotationFromObject(referencedImageId, annotationUID);
    }
    removeCropAnnotaionData(annotationUID);

    if (contextMenuOpen?.data?.annotationUID === annotationUID) {
      setContextMenuOpen(() => ({
        open: false,
        mouseEvt: null,
        data: null,
        showRemove: false,
      }));
    }

    return toolName !== undefined;
  };

  const removeSelectedMeasurement = () => {
    const protectedUIDs = collectProtectedAnnotationUIDs();
    const selected = annotation?.selection?.getAnnotationsSelected?.() || [];
    const selectedUIDs = Array.isArray(selected) ? selected : Array.from(selected);
    let removed = false;

    if (typeof annotation.state.getAllAnnotations === "function") {
      const highlightedUIDs = annotation.state
        .getAllAnnotations()
        .filter((ann) => ann?.highlighted && ann?.annotationUID)
        .map((ann) => ann.annotationUID);
      for (const annotationUID of highlightedUIDs) {
        if (!annotationUID || protectedUIDs.has(annotationUID)) {
          continue;
        }
        removed = removeAnnotationByUID(annotationUID) || removed;
      }
    }

    if (!removed) {
      for (const annotationUID of selectedUIDs) {
        if (!annotationUID || protectedUIDs.has(annotationUID)) {
          continue;
        }
        removed = removeAnnotationByUID(annotationUID) || removed;
      }
    }

    if (!removed && contextMenuOpen?.data?.annotationUID) {
      const contextUID = contextMenuOpen.data.annotationUID;
      if (!protectedUIDs.has(contextUID)) {
        removed = removeAnnotationByUID(contextUID) || removed;
      }
    }

    if (removed) {
      renderViewports();
    }
    return removed;
  };

  const removeAllMeasurements = () => {
    const protectedUIDs = collectProtectedAnnotationUIDs();
    const allAnnotations = annotation?.state?.getAllAnnotations?.() || [];
    let removed = false;

    const removableUIDs = allAnnotations
      .map((annotationItem) => annotationItem?.annotationUID)
      .filter((annotationUID) => annotationUID && !protectedUIDs.has(annotationUID));

    const uniqueUIDs = Array.from(new Set(removableUIDs));
    uniqueUIDs.forEach((annotationUID) => {
      removed = removeAnnotationByUID(annotationUID) || removed;
    });

    if (removed) {
      renderViewports();
    }
    return removed;
  };

  const handleDeleteSmartTag = (smartTag) => {
    setBoundingBoxMode(false);
    let isRender = false;
    for (const key in annotationData) {
      for (const key2 in annotationData[key]) {
        if (
          smartTag.id == key2 &&
          annotationData[key][key2] != undefined &&
          annotationData[key][key2].length > 0
        ) {
          annotationData[key][key2].map((item) => {
            if (item != null || item != undefined) {
              if(item.annotation?.annotationUID) {
                
                annotation.state.removeAnnotation(item.annotation.annotationUID);
                removeBoundingBoxFromObject(
                  item.annotation.metadata.referencedImageId,
                  item.annotation.annotationUID
                );
                isRender = true;
              }
            }
          });
        }
      }
    }
    for (const imageURLVar in annotationDataAI) {
      for (const pathId in annotationDataAI[imageURLVar]) {
        if (smartTag.id == pathId) {
          annotationDataAI[imageURLVar][pathId].forEach((item) => {
            annotation.state.removeAnnotation(item.annotation.annotationUID);
            isRender = true;
          });
        }
      }
    }    
    if(isRender)
      renderViewports();
  };

  const removeBoundingBoxFromObject = (imageURL, annotationUID) => {
    let annotationDataTemp = annotationData;
    imageURL = extractImageUrl(imageURL);
    let temp = annotationDataTemp[imageURL];
    let updateValues = temp;
    for (const key in temp) {
      updateValues[key] = temp[key].filter((item) => {
        if (item.annotation.annotationUID != annotationUID) {
          return item;
        }
      });
    }
    if (annotationData[imageURL]) {
      annotationDataTemp[imageURL] = updateValues;
    }
    setAnnotationData(annotationDataTemp);
    return true;
  };

  const removeTextAnnotationFromObject = (imageURL, annotationUID) => {
    let annotationDataTemp = allTextToolAnnotation;
    imageURL = extractImageUrl(imageURL);
    let temp = allTextToolAnnotation;
    let updateValues = temp;
    for (const key in temp) {
      updateValues = temp[key].filter((item) => {
        let parseJSON = JSON.parse(item);
        if (parseJSON.annotationUID != annotationUID) {
          return parseJSON;
        }
      });
    }
    if (allTextToolAnnotation[imageURL]) {
      annotationDataTemp[imageURL] = updateValues;
    }
    setAllTextToolAnnotation(annotationDataTemp);
  };

  const checkBoundingBoxExistPathalogy = (id) => {
    const keys = Object.keys(annotationData);

    for (const key in annotationData) {
      for (const key2 in annotationData[key]) {
        if (
          id == key2 &&
          annotationData[key][key2] != undefined &&
          annotationData[key][key2].length > 0
        ) {
          return true;
        }
      }
    }
    return false;

    // keys.forEach((key2, index) => {
    //   const keys2 = Object.keys(annotationData[key2]);
    //   keys2.forEach((key3,index)=>{
     //   })
    // });
  };

  const [originalImageActiveState, setOriginalImageActiveState] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const addViewportElement = (element) => {
    tempViewportElements.push(element);
    setViewportElements(tempViewportElements);
  };

  const changeActiveViewportIndex = (index) => {
    setActiveViewportIndex(index);
  };

  const changeViewportSeriesData = (seriesData) => {
    const { viewportIndex, studyId, ...rest } = seriesData;
    const tempViewportSeriesData = viewportSeriesData.map((data, i) => {
      if (i === viewportIndex) {
        return {
          ...rest,
          study: studyId,
        };
      }
      return data;
    });

    setViewportSeriesData(tempViewportSeriesData);
  };

  const changeViewportSeriesDataUpdated = (seriesData) => {
    const { viewportIndex, studyId, ...rest } = seriesData;
    setViewportSeriesData(prevData => {
      const updatedData = [...prevData];
      updatedData[viewportIndex] = {
        ...rest,
        study: studyId,
      };
      return updatedData;
    });
  };
  

  const changeLayout = (row, column) => {
    setViewportRow(row);
    setViewportColumn(column);
  };

  // dataSet defaults to the current study's data, falling back to priorStudyData[0]
  // when viewing priors (studyData stays empty on the priors route) - so callers
  // like LayoutSelector that don't know which mode they're in still get it right.
  const autoLoadSeriesInLayout = (
    row,
    column,
    dataSet = priorStudyData && priorStudyData.length > 0 ? priorStudyData[0] : studyData
  ) => {
    setViewportRow(row);
    setViewportColumn(column);

    const stacks = dataSet?.stacks || [];

    const newViewportSeriesData = Array.from({ length: VIEWPORT_ROW * VIEWPORT_COLUMN }, () => {
      return { study: "", stack: "", modality: "" };
    });

    let seriesIndex = 0;
    for (let r = 0; r < row; r++) {
      for (let c = 0; c < column; c++) {
        if (seriesIndex >= stacks.length) break;
        const viewportIdx = r * VIEWPORT_COLUMN + c;
        const stack = stacks[seriesIndex];
        const { studyId, ...rest } = buildSeriesDataFromStack(
          stack,
          dataSet?.originalStacks?.[seriesIndex] || null,
          dataSet?.heatmapStacks?.[seriesIndex] || null,
          dataSet?.outlineStacks?.[seriesIndex] || null,
          stack.modality,
          viewportIdx,
          seriesIndex
        );
        newViewportSeriesData[viewportIdx] = { ...rest, study: studyId };
        seriesIndex++;
      }
    }

    setViewportSeriesData(newViewportSeriesData);

    // Set active study/modality from the first loaded series so the report panel
    // recognises this as the parent study (not a prior).
    if (stacks.length > 0) {
      setActiveStudyId(stacks[0].studyId);
      setActiveModality(stacks[0].modality);
      changeActiveThumbnailIndex(0);
    }

    const hasAnySeries = newViewportSeriesData.some(v => v.stack !== "");
    if (hasAnySeries) {
      setIsAutoLoadLayout(true);
      setLoaderRunning(true);
      ref.current.continuousStart();
    }
  };

  const handleDefaultToolChange = () => {
    const assignPrimaryToStackScroll = (toolName) => {
      setMouseButtonToolAssignments((prev) => {
        const next = { ...prev };
        Object.keys(next).forEach((k) => {
          if (next[k] === toolName) {
            next[k] = null;
          }
        });
        next.primary = toolName;
        return next;
      });
    };

    if(isMPRActive) {
      if(SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST.includes(activeModality)){
        setActiveMPRTool(XRAY_DEFAULT_TOOL);
        assignPrimaryToStackScroll(XRAY_DEFAULT_TOOL);
      }else{
        if (activeMPRTool !== DEFAULT_TOOL) {
          setActiveMPRTool(DEFAULT_TOOL);
          assignPrimaryToStackScroll(DEFAULT_TOOL);
        }
      }
    } else {
      if(SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST.includes(activeModality)){
        setActiveTool(XRAY_DEFAULT_TOOL);
        assignPrimaryToStackScroll(XRAY_DEFAULT_TOOL);
      }else{
        if (activeTool !== DEFAULT_TOOL) {
          setActiveTool(DEFAULT_TOOL);
          assignPrimaryToStackScroll(DEFAULT_TOOL);
        }
      }
    }
  }

  const activeThumbnailIndexRef = useRef(activeThumbnailIndex);
  useEffect(() => {
    activeThumbnailIndexRef.current = activeThumbnailIndex;
  }, [activeThumbnailIndex]);

  const activeViewportIndexRef = useRef(activeViewportIndex);
  useEffect(() => {
    activeViewportIndexRef.current = activeViewportIndex;
  }, [activeViewportIndex]);

  const priorStudyDataRef = useRef(priorStudyData);
  useEffect(() => {
    priorStudyDataRef.current = priorStudyData;
  }, [priorStudyData]);

  const activeStudyIdRef = useRef(activeStudyId);
  useEffect(() => {
    activeStudyIdRef.current = activeStudyId;
  }, [activeStudyId]);

  const studyDataRef = useRef(studyData);
  useEffect(() => {
    studyDataRef.current = studyData;
  }, [studyData]);

  const isSeriesScrollEnabledRef = useRef(isSeriesScrollEnabled);
  useEffect(() => {
    isSeriesScrollEnabledRef.current = isSeriesScrollEnabled;
  }, [isSeriesScrollEnabled]);

  const isSynchronizedEnabledDataRef = useRef(isSynchronizedEnabled);
  useEffect(() => {
    isSynchronizedEnabledDataRef.current = isSynchronizedEnabled;
  }, [isSynchronizedEnabled]);

  const viewportSeriesDataRef = useRef(viewportSeriesData);
  useEffect(() => {
    viewportSeriesDataRef.current = viewportSeriesData;
  }, [viewportSeriesData]);

  const linkedViewportsRef = useRef(linkedViewports);
  useEffect(() => {
    linkedViewportsRef.current = linkedViewports;
  }, [linkedViewports]);

  const syncModeRef = useRef(syncMode);
  useEffect(() => {
    syncModeRef.current = syncMode;
  }, [syncMode]);

  // Auto-enable reference lines and synchronizer on first viewport load
  const autoEnableTriggeredRef = useRef(false);
  useEffect(() => {
    if (
      viewportLoadingComplete &&
      activeModality &&
      !autoEnableTriggeredRef.current
    ) {
      autoEnableTriggeredRef.current = true;
      // Auto-enable reference lines only for applicable modalities
      if (!REFLINES_SYNC_EXCLUDED_MODALITIES.includes(activeModality)) {
        setIsReferenceLineActivated(true);
        setIsReferenceLinesEnabled(true);
      }
      // Always auto-enable synchronizer in automatic mode for all modalities
      setSyncMode(SYNC_MODES.AUTOMATIC);
      setIsSynchronizedEnabled(true);
      enableStackScrollSync(
        0,
        SYNC_MODES.AUTOMATIC,
        viewportSeriesDataRef.current,
        linkedViewportsRef.current?.length > 0 ? linkedViewportsRef.current : null
      );
    }
  }, [viewportLoadingComplete, activeModality]);

  const setActiveOnSeriesScroll = (viewportIndex, viewportModality) => {
    if (isSynchronizedEnabledDataRef.current) {
      enableStackScrollSync(
        viewportIndex,
        syncModeRef.current,
        viewportSeriesDataRef.current,
        linkedViewportsRef.current?.length > 0 ? linkedViewportsRef.current : null
      );
    } else {
      disableStackScrollSync();
    }
    setActiveViewportModality(viewportModality);
    changeActiveViewportIndex(viewportIndex);
    
    changeActiveThumbnailIndex(
      viewportSeriesDataRef.current[viewportIndex].thumbnailIndex
    );
    setActiveModality(viewportModality);
    let studyIdString = viewportSeriesDataRef.current[viewportIndex].study;
    let studyIdInteger = parseInt(studyIdString, 10);
    setActiveStudyId(studyIdInteger);
    
  };

  // Find the active study index from the prior study list
  const getActivePriorStudyData = () => {
    let activePriorStudyIndex = -1;
    let activeStudyIndexStart = 0;
    let activeStudyIndexEnd = 0;
    let activePriorStudy = {};
    //let priorStudy = 
    // prior study
    for (let i = 0; i < priorStudyDataRef.current.length; i++) {
      const priorStudy = priorStudyDataRef.current[i];
    
      if (activeStudyIdRef.current === priorStudy.studyId) {
        activePriorStudy = priorStudy;
        activePriorStudyIndex = i;
        activeStudyIndexEnd = activeStudyIndexStart + priorStudy.stacks.length - 1;
        break; // Exit the loop when the condition is met
      } else {
        activeStudyIndexStart += priorStudy.stacks.length;
      }
    }
    
    return {
      activePriorStudy: activePriorStudy,
      activePriorStudyIndex: activePriorStudyIndex,
      activeStudyIndexStart: activeStudyIndexStart,
      activeStudyIndexEnd: activeStudyIndexEnd
    };
  }

 




  // Define the seriesScrollCallback function
  const seriesScrollCallback = (viewport, delta) => {
    // When series scroll is disabled, only scroll within the current series
    if (!isSeriesScrollEnabledRef.current) return;

    const viewportIndex = parseInt(viewport.id.split('_')[1]);

    if (viewportIndex !== activeViewportIndexRef.current) {
      const viewportModality = viewport.modality;
      setActiveOnSeriesScroll(viewportIndex, viewportModality);
    }

    // Determine if the viewport is at its scroll boundary
    let isAtEnd = false;
    let isAtStart = false;

    if (typeof viewport.getCurrentImageIdIndex === 'function' && viewport.imageIds) {
      // StackViewport boundary detection
      const currentImage = viewport.getCurrentImageIdIndex();
      isAtEnd = currentImage === (viewport.imageIds.length - 1);
      isAtStart = currentImage === 0;
    } else if (typeof viewport.getCamera === 'function') {
      // VolumeViewport boundary detection using scroll info
      try {
        const scrollInfo = getVolumeViewportScrollInfo(
          viewport,
          viewport.getVolumeId ? viewport.getVolumeId() : undefined
        );
        if (scrollInfo) {
          const { currentStepIndex, numScrollSteps } = scrollInfo;
          isAtEnd = currentStepIndex >= numScrollSteps;
          isAtStart = currentStepIndex <= 0;
        }
      } catch (e) {
        // If scroll info is unavailable, skip series change
        return;
      }
    }

    const activeThumbnailIndexCurrent = parseInt(activeThumbnailIndexRef.current);
 
    setIsScrollingUp(false);
    if(delta > 0 && isAtEnd) {
      if(priorStudyDataRef.current != undefined && priorStudyDataRef.current.length > 1) {
        const activePriorStudyData = getActivePriorStudyData();
        const noOfStacksInActiveStudy = activePriorStudyData.activePriorStudy.stacks.length;
        if(activePriorStudyData.activePriorStudyIndex != -1 && noOfStacksInActiveStudy > 1) {
          if(activeThumbnailIndexCurrent < activePriorStudyData.activeStudyIndexEnd)
            setStackScrollActiveThumbnailIndex(activeThumbnailIndexCurrent + 1);
          else {
            setStackScrollActiveThumbnailIndex(activePriorStudyData.activeStudyIndexStart);
          }
         }
      } else {
        // single study
        let noOfStacksInActiveStudy = studyDataRef.current?.stacks ? studyDataRef.current?.stacks.length: 0;
        if(noOfStacksInActiveStudy > 1) {
          if(activeThumbnailIndexCurrent < (noOfStacksInActiveStudy - 1))
            setStackScrollActiveThumbnailIndex(activeThumbnailIndexCurrent + 1);
          else
            setStackScrollActiveThumbnailIndex(0);
        }
      }
    } else if (delta < 0 && isAtStart) {
      if(priorStudyDataRef.current != undefined && priorStudyDataRef.current.length > 1) {
        const activePriorStudyData = getActivePriorStudyData();
        const noOfStacksInActiveStudy = activePriorStudyData.activePriorStudy.stacks.length;
        if(activePriorStudyData.activePriorStudyIndex != -1 && noOfStacksInActiveStudy > 1) {
          setIsScrollingUp(true);
          if(activeThumbnailIndexCurrent > activePriorStudyData.activeStudyIndexStart)
            setStackScrollActiveThumbnailIndex(activeThumbnailIndexCurrent - 1);
          else
            setStackScrollActiveThumbnailIndex(activePriorStudyData.activeStudyIndexEnd);
        }
      } else {
        // single study
        let noOfStacksInActiveStudy = studyDataRef.current?.stacks ? studyDataRef.current?.stacks.length: 0;
        if(noOfStacksInActiveStudy > 1) {
          setIsScrollingUp(true);
          if(activeThumbnailIndexCurrent > 0)
            setStackScrollActiveThumbnailIndex(activeThumbnailIndexCurrent - 1);
          else 
            setStackScrollActiveThumbnailIndex(noOfStacksInActiveStudy - 1);
        }
      }
   }    
  };

  // Remembers the HP that was last live so toggling the tool back on restores the
  // same one instead of always falling back to the best match.
  const lastAppliedHpRef = useRef(null);
  // False until the first hang completes — see the first-slot fallback in
  // applyHangingProtocol.
  const hasHungOnceRef = useRef(false);

  useEffect(() => {
    if(appliedHp && appliedHp != undefined && Object.keys(appliedHp).length ){
      lastAppliedHpRef.current = appliedHp;
      setViewportRow(0);
      setViewportColumn(0);
      clearViewportSeriesData();
      setIsHpApplied(true);
    }
  },[appliedHp]);

  useEffect(() => {
    if(appliedHp && appliedHp != undefined && Object.keys(appliedHp).length &&
     viewportColumn == 0){
        applyHangingProtocol();
    }
  },[appliedHp, viewportColumn]);

  useEffect(() => {
    if (hpDataList && Object.keys(hpDataList).length !== 0 && !isMobile) {
      const run = async () => {
        const hpPercentage = await calculateHpDtoMatchPercentage();
        setHpPercentageMap(hpPercentage);
        if (!hpPercentage || hpPercentage.size === 0) {
          setHpNotFound(true);
        }
      };
      run();
    }
    // For a priors study, calculateHpDtoMatchPercentage matches against
    // priorStudyData[0] (the parent's own stacks, in priors-array shape) rather
    // than studyData, whose priors-mode population is commented out above. Both
    // hpDataList and generatePriorStudyData(...) (which fills priorStudyData) are
    // kicked off from the same API response, but the latter is async and reliably
    // resolves after hpDataList commits - so on the very first run priorStudyData
    // is still [], matching falls back to the (empty, for priors) studyData, and
    // every hpDto scores 0. Since this effect only depended on hpDataList, it
    // never re-ran once priorStudyData actually arrived, so HP permanently never
    // applied for a fresh priors load. Re-running once priorStudyData populates
    // fixes that without affecting the non-priors case (it just stays []).
  },[hpDataList, priorStudyData]);

  useEffect(() =>{
    if (hpPercentageMap.size > 0) { 
      const bestMatchingHp = getMaxPercentageHp(hpPercentageMap);
      if(bestMatchingHp){
        setAppliedHp(bestMatchingHp);
      }else{
        setHpNotFound(true);
      }
    }
  }, [hpPercentageMap]);

  const getMaxPercentageHp = (matchPercentageMap) => {
    if (!hpDataList.length || !matchPercentageMap.size) return null;
  
    let maxHpDto = null;
    let maxPercentage = 0;
    let maxConditionsCount = 0;
  
    hpDataList.forEach(hpDto => {
      const percentage = matchPercentageMap.get(hpDto.name) || 0;
  
      if (percentage > maxPercentage) {
        maxPercentage = percentage;
        maxHpDto = hpDto;
        maxConditionsCount = countHpDtoConditions(hpDto);
      } else if (percentage === maxPercentage) {
        const currentConditionsCount = countHpDtoConditions(hpDto);
        if (currentConditionsCount > maxConditionsCount) {
          maxHpDto = hpDto;
          maxConditionsCount = currentConditionsCount;
        }
      }
    });
  
    return maxPercentage != 0 ? maxHpDto : null;
  };

  const countHpDtoConditions = (hpDto) => {
    let count = 0;
  
    hpDto.layout.viewportList.forEach(viewport => {
      count += (viewport.seriesConditions?.length || 0);
      count += (viewport.imageConditions?.length || 0);
    });
  
    return count;
  };

  const calculateHpDtoMatchPercentage = async () => {
    let matchPercentageMap = new Map();
  
    for (const hpDto of hpDataList) {

      const viewportDataMap = new Map();

      for (const viewport of hpDto.layout.viewportList) {
        
        let matchingStackIndex = -1
        let matchingImageIndex = -1;
        const studyDatasSet = priorStudyData && priorStudyData.length > 0 ? priorStudyData[0] : studyData;
        const matchingStackIndices = studyDatasSet.stacks
          .map((stack, index) => ({ index, matches: checkSeriesConditions(stack, viewport.seriesConditions) }))
          .filter(stack => stack.matches)
          .map(stack => stack.index); 
        
        for (const stackIndex of matchingStackIndices) {

          matchingImageIndex = await findMatchingImageIndex(studyDatasSet, stackIndex, viewport);
          // matchingImageIndex = studyDatasSet.stacks[stackIndex]?.images?.findIndex(stack =>
          //   checkImageConditions(stack, viewport.imageConditions, studyDatasSet.stacks[stackIndex]?.imageIds[0])
          // );
        
          if (matchingImageIndex !== -1) {
            matchingStackIndex = stackIndex;
            const key = `${viewport.row}-${viewport.column}`;
            viewportDataMap.set(key, {
              row: viewport.row,
              column: viewport.column,
              matchingStackIndex,
              matchingImageIndex,
            });
            break;
          }
        }
      }

      const totalViewports = hpDto.layout.rows * hpDto.layout.columns;

      const matchedViewports = viewportDataMap.size;
      const matchPercentage = (matchedViewports / totalViewports) * 100;

      matchPercentageMap.set(hpDto.name, matchPercentage);
      setHpViewportMap(prevMap => {
        const newMap = new Map(prevMap); 
        newMap.set(hpDto.name, viewportDataMap); 
        return newMap;
      });
    }
    return matchPercentageMap;
  };

  const applyHangingProtocol = async () =>{
    if(appliedHp && appliedHp != undefined && Object.keys(appliedHp).length ){
      setHpLoading(true);
      // await clearViewportSeriesData();

      const layout = appliedHp.layout;
      changeLayout(layout.rows, layout.columns);

      const newMatchingStackIndices = [];
      // Built fresh and replaced wholesale below. Merging into the previous maps
      // left keys behind from the HP being switched away from, and
      // applyViewportLayout completes the loader from max(viewportHpLayout keys) —
      // a stale key points at a viewport the new (smaller) layout never mounts, so
      // nothing ever cleared hpLoading and the loader span forever.
      const newViewportHpLayout = new Map();
      const newViewportHpImage = new Map();

      layout.viewportList.map((viewport, index) => {
        const viewportIndexes = hpViewportMap.get(appliedHp.name)?.get(`${viewport.row}-${viewport.column}`);
        const matchingStackIndex= viewportIndexes ? viewportIndexes.matchingStackIndex : -1;
        const matchingImageIndex= viewportIndexes ? viewportIndexes.matchingImageIndex : -1;
        
        if (matchingStackIndex !== -1 && matchingImageIndex !== -1) {
          const matchingStack = priorStudyData && priorStudyData.length > 0 ? priorStudyData[0].stacks[matchingStackIndex] : studyData.stacks[matchingStackIndex];
          // Flat index must use VIEWPORT_COLUMN to match the grid; a hardcoded 3 hung multi-row HPs.
          const viewportIdx = (viewport.row - 1) * VIEWPORT_COLUMN + (viewport.column - 1);

          const hpSeriesData = buildSeriesDataFromStack(
              matchingStack,
              priorStudyData && priorStudyData.length > 0 ? priorStudyData[0].originalStacks[matchingStackIndex] : studyData.originalStacks[matchingStackIndex],
              priorStudyData && priorStudyData.length > 0 ? priorStudyData[0].heatmapStacks[matchingStackIndex] : studyData.heatmapStacks[matchingStackIndex],
              priorStudyData && priorStudyData.length > 0 ? priorStudyData[0].outlineStacks[matchingStackIndex] : studyData.outlineStacks[matchingStackIndex],
              matchingStack.modality,
              viewportIdx,
              matchingStackIndex
          );
          changeViewportSeriesDataUpdated(hpSeriesData);

          newMatchingStackIndices.push(matchingStackIndex);

          newViewportHpLayout.set(viewportIdx, viewport);
          newViewportHpImage.set(viewportIdx, matchingImageIndex);
        }
      });

      // A protocol needn't match the first grid slot (e.g. one matching only 1-2
      // and 2-2). On study open the ordinary startup load still puts the first
      // series in viewport 0, so the hang looks complete — but that load is a
      // one-shot. Re-hanging clears every viewport and repopulates only matched
      // ones, which would leave viewport 0 permanently blank. Seed it with the
      // first series so a re-hang shows what the initial hang showed. Skipped on
      // the very first hang, where the startup load already covers it.
      if (hasHungOnceRef.current && !newViewportHpLayout.has(0)) {
        const dataSet =
          priorStudyData && priorStudyData.length > 0 ? priorStudyData[0] : studyData;
        const firstStack = dataSet?.stacks?.[0];
        if (firstStack) {
          changeViewportSeriesDataUpdated(
            buildSeriesDataFromStack(
              firstStack,
              dataSet.originalStacks?.[0] || null,
              dataSet.heatmapStacks?.[0] || null,
              dataSet.outlineStacks?.[0] || null,
              firstStack.modality,
              0,
              0
            )
          );
          newMatchingStackIndices.push(0);
          // Image index only — no viewportHpLayout entry, since the protocol has
          // no viewport spec for this slot to rotate/flip/window from.
          newViewportHpImage.set(0, 0);
        }
      }
      hasHungOnceRef.current = true;

      setViewportHpLayout(newViewportHpLayout);
      setViewportHpImage(newViewportHpImage);

      // If no viewports matched, stop the loader immediately
      if (newMatchingStackIndices.length === 0) {
        setHpLoading(false);
      }

      setHPThumbnailIds(newMatchingStackIndices);
    }
  }

  // Drops the live hanging protocol and returns to the viewer default: 1x1 layout
  // with the study's first series in the first viewport.
  const exitHangingProtocol = async () => {
    // Reset before the layout collapses to 1x1 — the extra viewports unmount and
    // their HP rotation/flip/WW-WL would then be unreachable.
    await Promise.all(
      [...viewportHpLayout.keys()].map((idx) => resetViewportTransforms(idx))
    );

    setViewportHpLayout(new Map());
    setViewportHpImage(new Map());
    setHPThumbnailIds([]);
    setHpLoading(false);
    setIsHpApplied(false);
    setAppliedHp({});

    autoLoadSeriesInLayout(
      1,
      1,
      priorStudyData && priorStudyData.length > 0 ? priorStudyData[0] : studyData
    );
    setTimeout(() => resizeViewport(), 300);
  };

  // Re-applies the previously applied HP, or the best match on a first run.
  // Returns false when the study has no usable protocol.
  const reapplyHangingProtocol = () => {
    const hpToApply = lastAppliedHpRef.current || getMaxPercentageHp(hpPercentageMap);
    if (!hpToApply) return false;
    setAppliedHp(hpToApply);
    return true;
  };

  function checkSeriesConditions(stack, conditions) {
    return conditions.every(condition => checkCondition(stack, condition));
  }

   async function findMatchingImageIndex(studyDatasSet, stackIndex, viewport) {
    const images = studyDatasSet.stacks[stackIndex]?.images || [];
    const imageId = studyDatasSet.stacks[stackIndex]?.imageIds[0];

    const allEmpty = viewport.imageConditions?.every(cond =>
      !cond.operand ||
      !cond.tag ||
      !cond.operandValue ||
      !cond.tagValue ||
      !cond.value || cond.value.length === 0 || cond.value.every(v => v === '')
    );

    if (allEmpty) {
      return 0;
    }
  
    for (let i = 0; i < images.length; i++) {
      const stack = images[i];
      const matches = await checkImageConditions(stack, viewport.imageConditions, imageId);
      if (matches) return i;
    }
  
    return -1;
  }
  
  async function checkImageConditions(stack, conditions, imageId) {
    const results = await Promise.all(
      conditions.map((cond) => checkImageCondition(stack, cond, imageId))
    );
    return results.every(Boolean);
  }

  async function checkImageCondition(stack, condition, imageId) {
    let tagValue;

    const isEmptyCondition =
    (!condition.tag || condition.tag.trim() === "") &&
    (!condition.operand || condition.operand.trim() === "") &&
    (condition.value === undefined ||
      condition.value === null ||
      (Array.isArray(condition.value) && condition.value.length === 0));

    if (isEmptyCondition) {
      return true;
    }

    switch (condition.tag) {
      case HP_META_TAGS.SOP_CLASS_UID:
        tagValue = stack.sopClassUID;
        return evaluateCondition(tagValue, condition.operand, condition.value);
      case HP_META_TAGS.INSTANCE_NUMBER:
        tagValue = stack.instanceNumber;
        return evaluateCondition(tagValue, condition.operand, condition.value);
    }
  
    let image = imageCacheRef.current.get(imageId);

    if (!image) {
      image = await loadAndCacheImage(imageId);
      if (image) {
        imageCacheRef.current.set(imageId, image);
      } else {
        return false;
      }
    }
  
    return await evaluateTagCondition(image.data, condition);
  }
  
  async function evaluateTagCondition(data, condition) {
    if (!data) {
      console.warn("Image data is not loaded.");
      return false;
    }
  
    let tagValue;
  
    switch (condition.tag) {
      case HP_META_TAGS.SAMPLES_PER_PIXEL:
        tagValue = data?.uint16('x00280002');
        break;
      case HP_META_TAGS.IMAGE_TYPE:
        tagValue = data?.string('x00080008');
        break;
      case HP_META_TAGS.IMAGE_LATERALITY:
        tagValue = data?.string('x00200062');
        break;
      case HP_META_TAGS.PATIENT_ORIENTATION:
        tagValue = data?.string('x00200020');
        break;
      case HP_META_TAGS.VIEW_POSITION:
        tagValue = data?.string('x00185101');
        break;
      case HP_META_TAGS.TRANSFER_SYNTAX_UID:
        tagValue = data?.string('x00020010');
        break;
      default:
        console.warn("Unknown tag:", condition.tag);
        return false;
    }
  
    return evaluateCondition(tagValue, condition.operand, condition.value);
  }
  
  function checkCondition(stack, condition) {
    let tagValue;

    // Map tag to the stack property using constants
    switch (condition.tag) {
        case HP_META_TAGS.MODALITY:
            tagValue = stack.modality;
            break;
        case HP_META_TAGS.BODY_PART_EXAMINED:
            tagValue = stack.bodyPart;
            break;
        case HP_META_TAGS.STUDY_DESCRIPTION:
            tagValue = stack.studyDescription;
            break;
        case HP_META_TAGS.SERIES_DESCRIPTION:
            tagValue = stack.seriesDescription;
            break;
        case HP_META_TAGS.SERIES_NUMBER:
            tagValue = stack.stackId;
            break;
        default:
          console.warn("Unknown tag:", condition.tag);
            return false;
    }

    // if (Array.isArray(condition.value)) {
    //   for (const singleValue of condition.value) {
    //     if (evaluateCondition(tagValue, condition.operand, singleValue)) {
    //       return true;
    //     }
    //   }
    //   return false;
    // }

    return evaluateCondition(tagValue, condition.operand, condition.value);
  }

// function evaluateCondition(tagValue, operand, value) {
//   if(tagValue == undefined){
//     return false;
//   }
  
//   if (typeof tagValue === "string" && typeof value === "string") {
//     tagValue = normalizeString(tagValue.toLowerCase());
//     value = normalizeString(value.toLowerCase());
//   }
//   switch (operand) {
//     case HP_OPERANDS.EQUALS:
//       return tagValue == value;
//     case HP_OPERANDS.NOT_EQUALS:
//       return tagValue !== value;
//     case HP_OPERANDS.CONTAINS:
//       return String(tagValue).toLowerCase().includes(String(value).toLowerCase());
//     case HP_OPERANDS.LESS_THAN:
//       return tagValue < value;
//     case HP_OPERANDS.GREATER_THAN:
//       return tagValue > value;
//     case HP_OPERANDS.LESS_THAN_EQUALS:
//       return tagValue <= value;
//     case HP_OPERANDS.GREATER_THAN_EQUALS:
//       return tagValue >= value;
//     default:
//       console.log("Unknown operand:", operand);
//       return false;
//   }
// }

function evaluateCondition(tagValue, operand, value) {
  if (tagValue === undefined || tagValue === null) {
    return false;
  }

  // Normalize inputs
  const normalize = (val) => normalizeString(String(val).toLowerCase());

  const testCondition = (singleVal) => {
    if (typeof singleVal === "string" && typeof tagValue === "string") {
      singleVal = normalize(singleVal);
      tagValue = normalize(tagValue);
    }

    switch (operand) {
      case HP_OPERANDS.EQUALS:
        return singleVal == tagValue;
      case HP_OPERANDS.NOT_EQUALS:
        return singleVal != tagValue;
      case HP_OPERANDS.CONTAINS:
        return String(tagValue).toLowerCase().includes(String(singleVal).toLowerCase());
      case HP_OPERANDS.LESS_THAN:
        return singleVal < tagValue;
      case HP_OPERANDS.GREATER_THAN:
        return singleVal > tagValue;
      case HP_OPERANDS.LESS_THAN_EQUALS:
        return singleVal <= tagValue;
      case HP_OPERANDS.GREATER_THAN_EQUALS:
        return singleVal >= tagValue;
      default:
        console.warn("Unknown operand:", operand);
        return false;
    }
  };

  if (Array.isArray(value)) {
    return value.some((val) => testCondition(val));
  }

  return testCondition(value);
}


function normalizeString(str) {
  return str.replace(/\s+/g, ' ').trim().toLowerCase();
}

 const clearViewportSeriesData = () => {
  setViewportSeriesData(() => {
    let array = [];
    for (let i = 0; i < VIEWPORT_COLUMN * VIEWPORT_ROW; i++) {
      array.push({ study: "", stack: "", modality: "" });
    }
    return array;
  });
}

const handleRemoveWarning = () => {
  
     setEditWarning(() => {
      let newVal = { ...editWarning };
      newVal.show = false;
      newVal.success = false;
      newVal.id = null;
      newVal.name = "";
      return newVal;
    });
    setDisableAddPathology(false);
    setPreviousActiveTool(activeTool);
    handleDefaultToolChange();
    setBoundingBoxMode(false);
  
};

const removeWarning = () => {
  setEditWarning(() => {
    let newVal = { ...editWarning };
    newVal.show = false;
    newVal.success = false;
    newVal.id = null;
    newVal.name = "";
    return newVal;
  });
};
const [sharedSlabThickness, setSharedSlabThickness] = useState(0.05);
const [sharedMprBlendMode, setSharedMprBlendMode] = useState("MIP");
const [isSpineLabellingActive, setIsSpineLabellingActive] = useState(false);
const [spineLabels, setSpineLabels] = useState([]);
const [spinePhase, setSpinePhase] = useState("select"); // 'select' | 'placing' | 'complete'

  return (
    <ViewportContext.Provider
      value={{
        sharedSlabThickness,
        isSpineLabellingActive,
        setIsSpineLabellingActive,
        spineLabels,
        setSpineLabels,
        spinePhase,
        setSpinePhase,
        setSharedSlabThickness,
        sharedMprBlendMode,
        setSharedMprBlendMode,
        activeViewportIndex,
        viewportRow,
        viewportColumn,
        changeActiveViewportIndex,
        changeLayout,
        autoLoadSeriesInLayout,
        isAutoLoadLayout,
        setIsAutoLoadLayout,
        viewportElements,
        changeViewportSeriesData,
        changeViewportSeriesDataUpdated,
        viewportSeriesData,
        addViewportElement,
        activeTool,
        setActiveTool,
        mouseButtonToolAssignments,
        assignMouseButtonToAssignableTool,
        togglePrimaryMouseAssignmentForTool,
        previousActiveTool,
        setPreviousActiveTool,
        showOverlay,
        setShowOverlay,
        testPatientViewerParent,
        setTestPatientViewerParent,
        handlePencilClick,
        boundingBox,
        currentActiveTag,
        setCurrentActiveTag,
        activeId,
        setActiveId,
        activeColor,
        setActiveColor,
        hideBoundingBox,
        contextMenuOpen,
        setContextMenuOpen,
        handleRemoveBoundingBox,
        originalImageActiveState,
        setOriginalImageActiveState,
        annotationData,
        setEditWarning,
        editWarning,
        checkBoundingBoxExistPathalogy,
        handleDeleteSmartTag,
        setIsCineEnabled,
        isCineEnabled,
        disableAddPathology,
        setDisableAddPathology,
        setIsSynchronizedEnabled,
        isSynchronizedEnabled,
        syncMode,
        setSyncMode,
        linkedViewports,
        setLinkedViewports,
        annotationDataAI,
        setAnnotationDataAI,
        removeBB,
        addAiBb,
        addLockedAIPathology,
        setAnnotationAddedSuccess,
        // databasePointsToMeasurement,
        addedAnnotation,
        setAddedAnnotation,
        isMPRActive,
        setIsMPRActive,
        mprViewportElements,
        setMprViewportElements,
        mprLoading,
        setMprLoading,
        activeMPRViewportIndex,
        setActiveMPRViewportIndex,
        activeMPRTool,
        setActiveMPRTool,
        previousActiveMPRTool,
        setPreviousActiveMPRTool,
        mprSeriesData,
        setMprSeriesData,
        dragEvent,
        setDragEvent,
        thumbnailDropEvent,
        setThumbnailDropEvent,
        thumbnailClickEvent,
        setThumbnailClickEvent,
        activeViewportModality,
        setActiveViewportModality,
        addBoundingBoxToViewport,
        studyBoundingBox,
        restoreBoundingBox,
        isMPRCineEnabled,
        setIsMPRCineEnabled,
        isCompareActive,
        setIsCompareActive,
        showCompare,
        setShowCompare,
        showImpressions,
        setShowImpressions,
        isSagittalActive,
        setIsSagittalActive,
        isAxialActive,
        setIsAxialActive,
        isCoronalActive,
        setIsCoronalActive,
        is3DActive,
        setIs3DActive,
        isReferenceLinesEnabled,
        setIsReferenceLinesEnabled,
        allTextToolAnnotation,
        setAllTextToolAnnotation,
        addTextAnnotationToViewport,
        setAllowAddingTextAnnotation,
        isMPRViewportActivate,
        setIsMPRViewportActivated,
        allowAddingTextAnnotation,
        addedStoreAnnotation,
        setAddedStoreAnnotation,
        parentLockReference,
        setParentLockReference,
        archivedPathology,
        setArchivedPathology,
        handleChangeLabelForTextAnnotation,
        removeSelectedMeasurement,
        removeAllMeasurements,
        isChildStudyActive,
        viewportImageLoaded,
        markViewportImageLoaded,
        showPriorStudyTopBar,
        setShowPriorStudyTopBar,
        isReferenceLineActivated,
        setIsReferenceLineActivated,
        imageLoadedOnViewport,
        setImageLoadedOnViewport,
        updateBBPosition,
        isUserInfoClicked, setIsUserInfoClicked,
        viewportLoadingComplete, setViewportLoadingComplete,
        mprViewportLoaderRunning, setMPRViewportLoaderRunning,
        volumeId, setVolumeId,
        handleDefaultToolChange,
        isScrollingUp,
        setIsScrollingUp,
        isSeriesScrollEnabled,
        setIsSeriesScrollEnabled,
        seriesScrollCallback,
        viewportHpLayout,
        viewportHpImage,
        setViewportRow,
        setViewportColumn,
        viewportOldState,
        setViewportOldState,
        setViewportSeriesData,
        updateViewportProperties,
        viewportStates,
        viewportDoubleClickIndex, setViewportDoubleClickIndex,
        viewportDoubleClickIndexConst, setViewportDoubleClickIndexConst,
        isMPREnabled,
        setIsMPREnabled,
        boundingBoxMode,
        setBoundingBoxMode,
        handleRemoveWarning,
        changeAiBbVisibility,
        applyHangingProtocol,
        exitHangingProtocol,
        reapplyHangingProtocol,
        hPThumbnailIds,
        boundingBoxAdding, setBoundingBoxAdding,
        isSrSelected, setIsSrSelected,
        isCropEnable , setIsCropEnable,
        maskingConfirm, setMaskingConfirm,
        disableMasking,


      }}
    >
      {props.children}
    </ViewportContext.Provider>
  );
};

export default ViewportState;
